import React, { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { useController, useFormContext } from 'react-hook-form';
import SelectField from '@wix/da-ds/pkg/Dropdown/select/SelectField';
import { DropdownOption } from '@wix/da-ds/pkg/Dropdown/types';
import { QuestionFieldName } from '../../types';

interface Props {}

const AnswerTypeField: React.FC<Props> = () => {
  const { t } = useTranslation();
  const id = useId();
  const { control } = useFormContext();
  const {
    field: { value, onChange },
  } = useController({ name: QuestionFieldName.QUESTION_TYPE, control });

  const items: DropdownOption[] = [
    {
      label: t('originalDeviationPopup.questionnaire.form.answerType.freeText'),
      value: 'free_text',
      selected: value === 'free_text',
    },
    {
      label: t(
        'originalDeviationPopup.questionnaire.form.answerType.singleChoice'
      ),
      value: 'single_choice',
      selected: value === 'single_choice',
    },
    {
      label: t(
        'originalDeviationPopup.questionnaire.form.answerType.multipleChoice'
      ),
      value: 'multiple_choice',
      selected: value === 'multiple_choice',
    },
  ];

  return (
    <SelectField
      id={id}
      label={t('originalDeviationPopup.questionnaire.form.answerType.label')}
      items={items}
      value={value}
      onChange={onChange}
      withBlankOption={false}
      showPrefixIcons={true}
    />
  );
};
AnswerTypeField.displayName = 'AnswerTypeField';

export default AnswerTypeField;
